import * as api from 'helpers/api';
import { renameProp } from 'helpers/object_helpers';

export const ADD_CLIENT_REPORT_CARD = 'add_client_report_card';
export const BATCH_UPDATE_CLIENT_REPORT_CARDS = 'batch_update_client_report_cards';
export const DELETE_PROJECT = 'delete_project';
export const LOAD_METRICS = 'load_metrics';
export const RESEND_CLIENT_REPORT_SHAREABLE_TOKEN = 'resend_client_report_shareable_token';
export const REMOVE_CLIENT_REPORT_CARD = 'remove_client_report_card';
export const UPDATE_CLIENT_REPORT_CARD = 'update_client_report_card';
export const UPDATE_LISTING = 'update_listing';
export const UPDATE_PROJECT = 'update_project';

export function updateVaultData(updatedVaultData) {
  return dispatch => dispatch({ type: UPDATE_PROJECT, payload: updatedVaultData });
}

const transformProjectData = (projectData) => {
  return renameProp('research_property', 'research_property_attributes', projectData);
};

export function updateProject(projectId, projectData) {
  return (dispatch) => {
    return api.put(`/projects/${projectId}`, { project: transformProjectData(projectData) }).then((data) => {
      dispatch({
        type: UPDATE_PROJECT,
        payload: data.project
      });
    });
  };
}

export function deleteProject(projectId, successCallback, errorCallback) {
  const request = api.deleteRequest(`/projects/${projectId}`);

  return (dispatch) => {
    request.then((response) => {
      dispatch({
        type: DELETE_PROJECT,
        payload: response.project
      });
      if (successCallback) successCallback(response.redirectTo);
    }).catch((response) => {
      if (errorCallback) errorCallback(response.response.data.errors);
    });
  };
}

export function updateListing(listing) {
  return {
    type: UPDATE_LISTING,
    payload: listing
  };
}

export function updateCollaborators(projectId, users) {
  const projectData = { collaborators: users.map(x => x.id) };
  return updateProject(projectId, projectData);
}

export function updateNotificationsBlockedUserIds(userIds) {
  return (dispatch, getState) => {
    const projectData = { notifications_blocked_user_ids: userIds };
    return dispatch(updateProject(getState().project.id, projectData));
  };
}

export function addContact(projectId, contactId, contactType, role) {
  const data = {
    contactRolesAttributes: [{
      contactId,
      contactType,
      relationship: role
    }]
  };

  return updateProject(projectId, data);
}

export function updateContactRole(projectId, id, role) {
  const data = {
    contactRolesAttributes: [{
      id,
      relationship: role
    }]
  };

  return updateProject(projectId, data);
}

// contactRolesAttributes = [{ contactId, contactType, relationship }]
export function addContactRoles(projectId, contactRolesAttributes) {
  return updateProject(projectId, { contactRolesAttributes });
}

export function removeContact(projectId, contactRoleId) {
  const data = {
    contactRolesAttributes: [{
      id: contactRoleId,
      '_destroy': true
    }]
  };

  return updateProject(projectId, data);
}

export function addClientReportCard(cardData) {
  return (dispatch, getState) => {
    const path = `/projects/${getState().project.id}/client_report_cards`;

    return api.post(path, { projectsClientReportCard: cardData }).then((response) => {
      dispatch({
        type: ADD_CLIENT_REPORT_CARD,
        payload: response
      });
    });
  };
}

export function removeClientReportCard(cardId) {
  return (dispatch, getState) => {
    const path = `/projects/${getState().project.id}/client_report_cards/${cardId}`;

    return api.deleteRequest(path).then(() => {
      dispatch({
        type: REMOVE_CLIENT_REPORT_CARD,
        payload: { cardId }
      });
    });
  };
}

export function updateClientReportCard(cardData) {
  return (dispatch, getState) => {
    const { id, ...params } = cardData;
    const path = `/projects/${getState().project.id}/client_report_cards/${id}`;

    return api.put(path, { projectsClientReportCard: params }).then(() => {
      dispatch({
        type: UPDATE_CLIENT_REPORT_CARD,
        payload: cardData
      });
    });
  };
}

export function batchUpdateClientReportCards(cards) {
  return (dispatch, getState) => {
    const path = `/projects/${getState().project.id}`;

    return api.put(path, { project: { clientReportCardsAttributes: cards } }).then(() => {
      dispatch({
        type: BATCH_UPDATE_CLIENT_REPORT_CARDS,
        payload: cards
      });
    });
  };
}

export function resendClientReportShareableToken(tokenId) {
  return (dispatch, getState) => api.put(`/projects/${getState().project.id}/shareable_tokens/${tokenId}/resend`);
}

export function updateAccessLevels(accessLevels, vaultId) {
  return (dispatch, getState) => {
    const project = getState().project;
    const vaultKeyToUpdate = project.saleVault?.id === vaultId ? 'saleVault' : 'leaseVault';
    const updatedVault = { ...project[vaultKeyToUpdate], accessLevels };
    dispatch({ type: UPDATE_PROJECT, payload: { [vaultKeyToUpdate]: updatedVault } });
  };
}
